import styled from 'styled-components';

export const OuterBurgerDiv = styled.div`
  position: relative;
  /* border: 2px solid red; */
`;

export const StyledMenu = styled.nav`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.black || 'black'};
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(-100%)')};
  min-height: 100vh;
  text-align: left;
  padding: var(--space-xxxl) var(--space-l) var(--space-l) var(--space-l);
  position: fixed;
  top: 0;
  left: 0;
  transition: transform 0.3s cubic-bezier(0.77, 0, 0.18, 1);
  width: 80vw;
  max-width: 350px;
  z-index: 200;
  .topNav {
    position: absolute;
    top: 18px;
    left: 18px;
    cursor: pointer;
  }
  .bottomNav {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing.xl || 'var(--space-xl)'};
    margin-top: ${({ theme }) => theme.spacing.xxl || 'var(--space-xxxl)'};
    max-height: calc(100vh - 80px);
    /* ensure last items can scroll above bottom controls */
    padding-bottom: 96px;
    /* border: 2px solid red; */
    box-sizing: border-box;
    /* allow vertical scrolling inside the menu */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    max-height: calc(100vh - 80px);
  }
  .menuSection {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xs || 'var(--space-xxs)'};
    /* border: 1px solid orange; */
  }
  .parentLink {
    font-weight: 800;
    color: ${({ theme }) => theme.colors.yellow4 || 'var(--yellow4)'};
    padding: 0.25rem 0;
  }

  .subLinks {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xxsm || 'var(--space-xxs)'};
    margin-left: var(--space-s);
  }

  .subLinks a {
    padding: 0.15rem 0;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.white || '#fff'};
    opacity: 0.95;
  }
  .menuSubtitle {
    font-size: var(--space-m);
    font-weight: 700;
    color: var(--yellow4);
    margin-bottom: var(--space-xxs);
    letter-spacing: 0.02rem;
    text-transform: uppercase;
    /* border: 2px solid red; */
  }
  a {
    color: ${({ theme }) => theme.colors.white || '#fff'};
    font-size: var(--space-m);
    font-weight: 600;
    text-decoration: none;
    transition: color 0.2s;
    display: flex;
    align-items: center;
    gap: var(--space-s);
    padding: var(--space-xxxs) 0;
    &:hover {
      color: ${({ theme }) => theme.colors.yellow3 || '#FFD600'};
    }
  }

  a.pillButton {
    background: ${({ theme }) => theme.colors.yellow4 || '#FFD600'};
    color: ${({ theme }) => theme.colors.black || '#000'};
    padding: var(--space-xxs) var(--space-m);
    border-radius: 999px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    gap: var(--space-s);
    text-decoration: none;
    transition:
      opacity 0.15s,
      transform 0.15s;
    &:hover {
      opacity: 0.95;
      transform: translateY(-1px);
    }
  }
`;
